export default {
  ExportGrid: 'export-grid',
  ExportGridSearchVoucher: 'export-grid-search-voucher',
  ExportDynamicTemplateImport: 'export-dynamic-template-import',
  ExportXmlFinance: 'export-xml-finance',
  ExportGridMulti: 'export-grid-multi',
  ExportGridMultiCustom: 'export-grid-multi-custom',
  ExportMergeReport: 'export-merge-report', // Xuất khẩu báo cáo mẫu merge
  ExportGridMultipleSheet: 'export-grid-multiple-sheet', // xuất exel cập nhật thông tư 23
  ExportGridGroupData: 'export-grid-group-data', // xuất excel có group data.
};